import type { DeepString } from "@/lib/i18n";

/**
 * CInteractiveMap - polskie tłumaczenia (search + empty states).
 */
export const pl = {
  search: "Wyszukaj",
  empty: "Brak danych do wyświetlenia.",
  emptyMap: "Mapa nie została jeszcze skonfigurowana.",
  noResults: "Brak wyników wyszukiwania.",
} as const;

export type CInteractiveMapTranslations = DeepString<typeof pl>;
